export const routerPaths = {
  root: '/',
  login: '/login',
  ssoSuccess: '/sso-authn',
  notes: '/notes',
  settings: '/settings',
  resetPassword: '/reset-password',
  forgotPassword: '/forgot-password',
  duplicateTab: '/duplicate-tab',
  support: '/support',
  adminNotes: '/a/notes',
  connectedNotes: '/a/notes/:providerId',
};

export const getPathWithParams = (path: string, params: Record<string, string>) => {
  let newPath = path;

  Object.entries(params).forEach(([key, value]) => {
    newPath = newPath.replace(`:${key}`, value);
  });

  return newPath;
};
